'use strict';
const { Operators } = require('./consts');

function getNumber(value) {
    const number = parseInt(value, 10);

    if (isNaN(number)) {
        return NaN;
    }

    if (String(number).length !== String(value).length) {
        return NaN;
    }

    return number;
}

const operators = {
    block: {
        or: (content, handler) => {
            return content
                .some(expr => handler(expr));
        },
        and: (content, handler) => {
            return content
                .every(expr => handler(expr));
        },
        not: (content, handler) => {
            return content.length && !handler(content[0]);
        }
    },
    condition: {
        [Operators.TRUE]: () => {
            return true;
        },
        [Operators.EXIST]: (currentValue = []) => {
            return Boolean(currentValue.length);
        },
        [Operators.EQUAL]: (currentValue = [], value) => {
            return currentValue.toString() === value.toString();
        },
        [Operators.NOT_EQUAL]: (currentValue = [], value) => {
            return currentValue.toString() !== value.toString();
        },
        [Operators.GT]: (currentValue = [], value) => {
            currentValue = getNumber(currentValue.toString());
            value = getNumber(value);

            if (!isNaN(currentValue) && !isNaN(value)) {
                return Number(currentValue) > Number(value);
            }

            return false;
        },
        [Operators.LT]: (currentValue = [], value) => {
            currentValue = getNumber(currentValue.toString());
            value = getNumber(value);

            if (!isNaN(currentValue) && !isNaN(value)) {
                return Number(currentValue) < Number(value);
            }

            return false;
        },
        [Operators.INCLUDES]: (currentValue = [], value) => {
            currentValue = currentValue.map(String);

            return value
                .every(item => currentValue.includes(String(item)));
        },
        [Operators.ANY]: (currentValue = [], value) => {
            value = value.map(String);

            return currentValue
                .some(item => value.includes(String(item)));
        },
        /* Не содержит все из набора */
        [Operators.NOT_INCLUDES_ALL]: (currentArray = [], includesThisArray) => {
            return !operators.condition[Operators.ANY](currentArray, includesThisArray);
        },
        /* Не содержит хоть что-то из набора */
        [Operators.NOT_INCLUDES_ANY]: (currentArray = [], includesThisArray) => {
            return !operators.condition[Operators.INCLUDES](currentArray, includesThisArray);
        },
        /* N и более ответов */
        [Operators.ANSWERS_COUNT_GT]: (currentValue = [], value) => {
            if (!Array.isArray(currentValue)) {
                return false;
            }

            const numberValue = Number(value);

            if (isNaN(numberValue)) {
                return false;
            }

            return currentValue.length >= numberValue;
        },
        /* N и менее ответов */
        [Operators.ANSWERS_COUNT_LT]: (currentValue = [], value) => {
            if (!Array.isArray(currentValue)) {
                return false;
            }

            const numberValue = Number(value);

            if (isNaN(numberValue)) {
                return false;
            }

            return currentValue.length <= numberValue;
        },
        [Operators.ANSWERS_COUNT]: (currentValue = [], value) => {
            if (!Array.isArray(currentValue)) {
                return false;
            }

            const numberValue = Number(value);

            if (isNaN(numberValue)) {
                return false;
            }

            return currentValue.length === numberValue;
        }
    }
};

module.exports = operators;
